<div class="min-h-screen">
  <main>
    <router-outlet></router-outlet>
  </main>
</div>
